import { isAxiosError } from 'axios'

export function getAxiosErrorStatus(error: unknown): number | undefined {
  if (!isAxiosError(error)) return undefined
  return error.response?.status ?? error.status
}

export function getAxiosErrorData<T>(error: unknown): T | undefined {
  if (!isAxiosError(error)) return undefined
  return error.response?.data as T | undefined
}
